import { useMemo } from 'react';

import { DocumentsTable } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { useFormContext } from 'modules/client/client/forms/withdrawalAccountsForm';
import {
  WithdrawalAccountItem,
  WithdrawalAccountsTable,
} from 'modules/client/common/components/sections/WithdrawalAccountsSection/FormContent/components';
import { v4 as uuidv4 } from 'uuid';

export interface FormContentProps {
  onRemoveWithdrawalAccount?: (row: WithdrawalAccountItem) => void;
  onCellClickWithdrawalAccount?: (row: WithdrawalAccountItem) => void;
}

export const FormContent = ({
  onRemoveWithdrawalAccount,
  onCellClickWithdrawalAccount,
}: FormContentProps) => {
  const { values, readOnly } = useFormContext();
  const { t } = useTranslation();

  const withdrawalAccountsOwnerConfirmationFiles = useMemo(
    () =>
      values.withdrawalAccounts
        .flatMap(
          (withdrawalAccount) => withdrawalAccount.ownerConfirmationFiles
        )
        .map((file) => ({
          id: file.id ?? uuidv4(),
          name: file.name,
          createdAt: file.createdAt,
          size: file.size,
        })),
    [values.withdrawalAccounts]
  );

  return (
    <Stack spacing={24}>
      <WithdrawalAccountsTable
        editable={!readOnly}
        items={values.withdrawalAccounts}
        onCellClick={onCellClickWithdrawalAccount}
        onClickDelete={onRemoveWithdrawalAccount}
      />

      <Stack spacing={12}>
        <Typography as="h3" variant="subtitle">
          {t('components.documentsTableFeature.title')}
        </Typography>

        <DocumentsTable files={withdrawalAccountsOwnerConfirmationFiles} />
      </Stack>
    </Stack>
  );
};
